import NetworkService from './network.service';

class UploadApi {
    static generateS3SignedUrl = async (
        s3Path: string,
        bucketName?: string
    ) => {
        let url = `api/common-service/generate-signed-url`;
        let data = await NetworkService.post(url, { s3Path, bucketName });
        return data && data.data ? data.data : data;
    };

    static uploadFileToS3 = async (
        s3Path: string,
        file: any,
        companyId?: string | number
    ) => {
        let url = `api/common-service/file-upload`;
        const formData = new FormData();
        formData.append('file', file);
        formData.append('path', s3Path);
        if (companyId !== undefined && companyId !== null) {
            formData.append('companyId', String(companyId));
        }
        let data = await NetworkService.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return data && data.data ? data.data : data;
    };

    static getInvoicePdfTemplateFileInfo = async (
        companyId: string | number,
        fileName: string
    ) => {
        let url = `api/common-service/invoice-pdf/template-file`;
        let data = await NetworkService.post(url, { companyId, fileName });
        return data && data.data ? data.data : data;
    };

    static getWorkOrderTemplateFileInfo = async (
        companyId: string | number,
        fileName: string
    ) => {
        let url = `api/common-service/workorder/template-file`;
        let data = await NetworkService.post(url, { companyId, fileName });
        return data && data.data ? data.data : data;
    };
}
export default UploadApi;
